<script setup>
import { useI18n } from "vue-i18n";

const { plan, plansBenefits } = defineProps(["plan", "plansBenefits"]);
const emit = defineEmits(["closeModal", "createSinglePayment"]);

const { t } = useI18n();

const createSinglePayment = async (plan, provider) => {
  emit("createSinglePayment", {
    plan: plan,
    provider: provider,
  });
};
</script>
<template>
  <VCard
    :class="plan.is_default ? 'default_plan' : 'plan'"
    style="margin-bottom: 110px"
    :key="plan.id"
  >
    <VCardItem>
      <div class="plan-container">
        <span class="plan-title"> {{ plan.name }} </span>
        <span class="plan-price-container">
          <span class="plan-price"> {{ plan.unit_price }} {{ plan.currency_symbol }} </span>
          <span class="plan-price-suffix"> / {{ t("billing.per_document") }} </span>
        </span>

        <v-menu>
          <template v-slot:activator="{ props }">
            <VBtn class="plan-button" variant="flat" v-bind="props">
              {{ t("billing.buy_now") }}
            </VBtn>
          </template>

          <v-list>
            <v-list-item
              :title="$t('billing.traditional_payments')"
              key="stripe"
              @click="() => createSinglePayment(plan.id, 'stripe')"
            />
            <v-list-item
              :title="$t('billing.crypto_payments')"
              key="vaiot"
              @click="() => createSinglePayment(plan.id, 'vaiot')"
            />
          </v-list>
        </v-menu>

        <div class="features-list">
          <span class="feature" v-for="feature in plansBenefits">
            <img src="/src/assets/icons/list-arrow.svg" />
            <span> {{ feature }} </span>
          </span>
        </div>
      </div>
    </VCardItem>
  </VCard>
</template>
<style scoped lang="scss">
.plan,
.default_plan {
  width: 320px;
  min-height: 365px;
  max-height: 365px;

  @media (max-width: 768px) {
    width: 100% !important;
    padding: 30px;
    padding-top: 0 !important;
    min-height: 310px !important;
    max-height: 310px !important;
    box-shadow: none !important;
  }
}

.plan-container {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;

  .plan-marker-icon {
    position: absolute;
    top: 0;
    left: 20px;
    width: 30px;
    height: 30px;
    z-index: 2;
  }

  .plan-title {
    width: 100%;
    display: flex;
    font-size: 1.25rem;
    color: var(--eerie-black);
    font-weight: 600;
    margin-bottom: 20px;
    margin-top: 20px;
    padding-left: 25px;

    @media (max-width: 768px) {
      margin-bottom: 0;
    }
  }

  .plan-price-container {
    display: flex;
    align-items: flex-start;
    gap: 6px;
  }

  .plan-price-subtitle {
    font-size: 0.875rem;
    color: var(--cambridge-blue);
    font-weight: bold;
    margin-left: 25px;
  }

  .plan-price {
    font-size: 1.5rem;
    color: var(--eerie-black);
    font-weight: bold;
    text-transform: uppercase;
    margin-left: 25px;
  }

  .plan-price-subtitle-suffix {
    font-size: 0.5rem;
    color: var(--cambridge-blue);
  }

  .plan-price-suffix {
    font-size: 0.688rem;
    color: var(--dark-grey);
    margin-top: 5px;
  }

  .plan-button {
    margin-top: 20px;
    background-color: var(--cambridge-blue);
    color: white;
    font-size: 1.125rem;
    font-weight: bold;
    padding: 5px;
    margin-right: 25px;
    margin-left: 25px;
  }
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 20px auto;

  @media (max-width: 768px) {
    margin: 20px 55px;
  }
}

.feature {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 0.688rem;
  color: var(--dark-grey);
}

.default_plan {
  min-height: 408px;
  position: relative;
  box-shadow: 0px 3px 6px #00000029;
}

.v-card-item {
  padding: 0;
}
</style>
